/**
 * LoveLab certificate UI animations — React CertificateSelector / IgiCertLightbox parity.
 * Fade+slide preview card; fade+scale modal.
 */
(function (window) {
  'use strict';

  var PREVIEW_SEL =
    '#ll-cuty-cert-preview, #ll-cubix-cert-preview, #ll-sienna-cert-preview, #ll-moonlight-cert-preview, #ll-iconix-cert-preview, [data-ll-cert-preview]';
  var MODAL_SEL =
    '#ll-cert-modal, #ll-sienna-cert-modal, #ll-moonlight-cert-modal, #ll-iconix-cert-modal, [data-ll-cert-modal]';
  var OUT_MS = 280;

  function enhancePreview(el) {
    if (!el || el.dataset.llCertEnhanced === '1') return el;
    el.dataset.llCertEnhanced = '1';
    el.classList.add('ll-cert-preview');
    return el;
  }

  function enhanceModal(el) {
    if (!el || el.dataset.llCertEnhanced === '1') return el;
    el.dataset.llCertEnhanced = '1';
    el.classList.add('ll-cert-modal');
    if (el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
    var panel = el.querySelector(':scope > div');
    if (panel) panel.classList.add('ll-cert-modal__panel');

    el.addEventListener('click', function (e) {
      if (e.target === el) closeModal(el);
    });
    return el;
  }

  function setPreview(el, open) {
    if (!el) return;
    enhancePreview(el);
    if (open) {
      el.style.display = 'flex';
      el.setAttribute('aria-hidden', 'false');
      el.classList.remove('ll-cert-preview--out');
      // Restart enter animation
      el.classList.remove('ll-cert-preview--in');
      void el.offsetWidth;
      el.classList.add('ll-cert-preview--in');
    } else {
      if (el.style.display === 'none' || getComputedStyle(el).display === 'none') {
        el.classList.remove('ll-cert-preview--in', 'll-cert-preview--out');
        return;
      }
      el.classList.remove('ll-cert-preview--in');
      el.classList.add('ll-cert-preview--out');
      el.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (el.classList.contains('ll-cert-preview--out')) {
          el.style.display = 'none';
          el.classList.remove('ll-cert-preview--out');
        }
      }, OUT_MS);
    }
  }

  function openModal(el) {
    if (!el) return;
    enhanceModal(el);
    el.style.display = 'flex';
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ll-cert-modal-open');
    el.classList.remove('ll-cert-modal--out');
    el.classList.remove('ll-cert-modal--in');
    void el.offsetWidth;
    el.classList.add('ll-cert-modal--in');
  }

  function closeModal(el) {
    if (!el) return;
    enhanceModal(el);
    el.classList.remove('ll-cert-modal--in');
    el.classList.add('ll-cert-modal--out');
    el.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      if (el.classList.contains('ll-cert-modal--out')) {
        el.style.display = 'none';
        el.classList.remove('ll-cert-modal--out');
        if (!document.querySelector('.ll-cert-modal.ll-cert-modal--in')) {
          document.body.classList.remove('ll-cert-modal-open');
        }
      }
    }, OUT_MS);
  }

  function findPreviewNear(node) {
    var root =
      (node &&
        node.closest(
          '.ll-cuty-options, .ll-cubix-options, .ll-matchy-options, .ll-shapy-options, .ll-multi-options, .ll-moonlight-options, .ll-sienna-options, .ll-iconix-options, .product__info-container, form'
        )) ||
      document;
    return root.querySelector(PREVIEW_SEL) || document.querySelector(PREVIEW_SEL);
  }

  function findModalNear(node) {
    var root =
      (node &&
        node.closest(
          '.ll-cuty-options, .ll-cubix-options, .ll-matchy-options, .ll-shapy-options, .ll-multi-options, .ll-moonlight-options, .ll-sienna-options, .ll-iconix-options, .product__info-container, form'
        )) ||
      document;
    return (
      root.querySelector(MODAL_SEL) ||
      document.querySelector(MODAL_SEL)
    );
  }

  function syncFromRadio(radio) {
    if (!radio) return;
    var preview = findPreviewNear(radio);
    var isIgi = String(radio.value || '').toLowerCase() === 'igi' && radio.checked;
    // igi-only products keep preview always visible
    var toggle = radio.closest('[data-ll-cert-toggle], .cert-toggle-wrap, .ll-sienna-cert-toggle-wrap');
    var hasInHouse =
      toggle &&
      toggle.querySelector(
        'input[name="ll_custom_cert"][value="In-house"], input[name="ll_custom_cert"][value="In house"]'
      );
    var show = isIgi || !hasInHouse;
    setPreview(preview, show);
  }

  function bind() {
    document.querySelectorAll(PREVIEW_SEL).forEach(enhancePreview);
    document.querySelectorAll(MODAL_SEL).forEach(enhanceModal);

    // Animate any preview that Liquid already left visible (IGI-only PDPs)
    document.querySelectorAll(PREVIEW_SEL).forEach(function (el) {
      var display = el.style.display || getComputedStyle(el).display;
      if (display === 'flex' || display === 'block') {
        setPreview(el, true);
      }
    });

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.matches || !t.matches('input[name="ll_custom_cert"]')) return;
        // Snippets open the lightbox; we only ensure the preview card animates.
        window.setTimeout(function () {
          syncFromRadio(t);
        }, 0);
      },
      false
    );

    function openModalFromTrigger(trigger) {
      if (!trigger) return;
      var onclick = trigger.getAttribute('onclick') || '';
      var match = onclick.match(/getElementById\(['"]([^'"]+)['"]\)/);
      var id = match && match[1];
      var modal = (id && document.getElementById(id)) || findModalNear(trigger);
      if (!modal) return;
      if (
        trigger.matches('[data-ll-open-cert-modal]') ||
        onclick.indexOf("display='flex'") !== -1 ||
        onclick.indexOf('display="flex"') !== -1
      ) {
        trigger.removeAttribute('onclick');
        trigger.addEventListener('click', function (ev) {
          ev.preventDefault();
          openModal(modal);
        });
        openModal(modal);
      }
    }

    // Intercept direct display toggles from inline onclick handlers
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('[onclick*="cert-modal"], [onclick*="Cert-modal"], [data-ll-open-cert-modal]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        openModalFromTrigger(btn);
      },
      true
    );

    // Open modal when clicking a cert preview image that is not already a button trigger
    document.addEventListener(
      'click',
      function (e) {
        var img = e.target.closest('.ll-cert-preview img, [data-ll-cert-preview] img');
        if (!img) return;
        if (e.target.closest('[onclick*="cert-modal"], [onclick*="Cert-modal"], [data-ll-open-cert-modal]')) {
          return;
        }
        var preview = img.closest('.ll-cert-preview, [data-ll-cert-preview]');
        var modal = findModalNear(preview || img);
        if (!modal) return;
        e.preventDefault();
        e.stopPropagation();
        openModal(modal);
      },
      true
    );

    // Close buttons inside modals
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('.ll-cert-modal button');
      if (!closeBtn) return;
      var modal = closeBtn.closest('.ll-cert-modal, [id$="-cert-modal"], #ll-cert-modal');
      if (!modal) return;
      var onclick = closeBtn.getAttribute('onclick') || '';
      if (onclick.indexOf("display='none'") !== -1 || onclick.indexOf('display="none"') !== -1 || closeBtn.matches('[data-ll-close-cert-modal]')) {
        e.preventDefault();
        e.stopPropagation();
        closeModal(modal);
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.ll-cert-modal.ll-cert-modal--in').forEach(closeModal);
    });
  }

  window.LoveLabCertUI = {
    setPreview: setPreview,
    openModal: openModal,
    closeModal: closeModal,
    syncFromRadio: syncFromRadio,
    enhancePreview: enhancePreview,
    enhanceModal: enhanceModal,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})(window);
